export default () => ({
  business: null,
  businesses: [],
  businessContacts: [],
  totalBusinesses: 0,
  searchTerm: '',
  pageSize: 10,
  sortDir: 'asc',
  orderBy: 'Name',
  status: '',
  filterBy: 0
})



// WEBPACK FOOTER //
// ./src/store/modules/businesses/state.js